import React, { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  PasswordInput,
  useRedirect,
} from "react-admin";
import { required, email, minLength } from "react-admin";
import passwordsMatch from "../../validators/passwordsMatch";
import EditConfirmToolbar from "../../components/EditConfirmToolbar";
import DataProvider from "../../DataProvider.js";
import { parse } from "query-string";
import NotificationSwitches from "../../components/NotificationSwitches";
import OrgSelector from "../../components/OrgSelector";
import { validateNotifications } from "../../validators/DispatchTabletValidate";

const DispatchTabletEdit = (props) => {
  const alertM = `Warning, this cannot be undone. This tablet will be deleted permanently.`;
  const redirectTo = useRedirect();

  const { organization_id } = parse(props.location.search);
  let [notifications, setNotifications] = useState({
    enabled_all_notifications: null,
    enabled_testdrill_notifications: null,
    enabled_emergency_notifications: null,
    enabled_tas_notifications: null,
    enabled_medical_notifications: null,
    enabled_lockdown_notifications: null,
    enabled_tornado_notifications: null,
    enabled_weather_notifications: null,
    enabled_falsealert_notifications: null,
    enabled_tamper_notifications: null,
    enabled_security_notifications: null,
    enabled_camera_weapon_detected_notifications: null,
    enabled_camera_crowd_detected_notifications: null,
    enabled_camera_fire_detected_notifications: null,
    enabled_camera_fight_detected_notifications: null,
    enabled_camera_face_detected_notifications: null,
  });

  const uploadData = async (data) => {
    const validNotifications = validateNotifications(notifications);
    if (!validNotifications) {
      alert("You must select an alert type");
      return;
    }
    const dispatchTabletData = await DataProvider.update("dispatch-tablets", {
      id: data.id,
      data: { ...data, notifications: notifications },
    });
    redirectTo(
      `/dispatch-tablets/${dispatchTabletData.data.id}/show?organization_id=${organization_id}`,
      dispatchTabletData
    );
  };

  return (
    <Edit {...props} title="Edit Dispatch Console">
      <SimpleForm
        {...props}
        toolbar={
          <EditConfirmToolbar
            handlesave={uploadData}
            tbredirect="/dispatch-tablets"
            alertmessage={alertM}
            dataprovidersource="dispatch-tablets"
            history={props.history}
          />
        }
        redirect="list"
      >
        <OrgSelector
          fullWidth
          source="org_id"
          {...props}
          locked={organization_id}
          cantogglelock={true}
          required
        />
        {/* <TextInput fullWidth label="Email" source="email" validate={[email()]} /> */}
        <TextInput fullWidth label="Location Name" source="displayName" />
        <TextInput fullWidth label="Notes" source="description" />
        {/* <PasswordInput fullWidth autoComplete="new-password" source="password" validate={[passwordsMatch, minLength(6)]} />
      <PasswordInput fullWidth autoComplete="new-password" source="confirm-password" validate={[passwordsMatch]} /> */}
        <NotificationSwitches
          notifications={notifications}
          setNotifications={setNotifications}
        />
      </SimpleForm>
    </Edit>
  );
};

export default DispatchTabletEdit;
